import React, { useEffect } from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "../../theme";
import { Link } from "react-router-dom";

const EnjoyFreshlyPreparedButton = styled(Button)(({ theme }) => ({
  background: "#F5933D",
  color: "#FFFFFF",
  borderRadius: "12px",
  padding: "16px 40px",
  fontSize: "16px",
  fontWeight: 600,
  fontFamily: "Inter",
  textTransform: "none",
  maxWidth: "200px",
  "&:hover": {
    background: "#E8843A",
    transform: "translateY(-2px) scale(1.05)",
    boxShadow: "0 8px 25px rgba(245, 147, 61, 0.4)",
  },
  "&:active": {
    transform: "translateY(0) scale(0.98)",
  },
  transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
}));

const EnjoyFreshlyPreparedSection: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <Box
      sx={{
        background: "#ffffff",
        overflow: "hidden",
        position: "relative",
        borderRadius: "48px",
        width: "100%",
        padding: ["0px 0 24px 0", "64px 0"],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          alignItems: "center",
          justifyContent: "flex-start",
          mx: "auto",
          px: 0,
          py: 3,
          width: "1109px",
          maxWidth: "calc(100% - 330px)",
          [theme.breakpoints.down("lg")]: {
            maxWidth: "calc(100% - 40px)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              height: "98px",
              justifyContent: "center",
              position: "relative",
              color: "#212225",
              fontSize: "90px",
              width: "90px",
            }}
          >
            ✨
          </Box>
          <Typography
            sx={{
              background: "linear-gradient(to right, #29bc62, #f5933d)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "44px",
              lineHeight: 1.5,
              textAlign: "center",
              width: "100%",
              [theme.breakpoints.down("md")]: {
                fontSize: "32px",
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "24px",
              },
            }}
          >
            {t("common.enjoyFreshlyPrepared.description")}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <Link style={{ textDecoration: "none", color: "#FFFFFF" }} to={"/all-plans"}>
            <EnjoyFreshlyPreparedButton>{t("common.enjoyFreshlyPrepared.exploreButton")}</EnjoyFreshlyPreparedButton>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default EnjoyFreshlyPreparedSection;
